import { GET_LINK_RECOMMENDER_QUERY } from "components/feature-entity-linking-page/queries/queries";
import { EntityType } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { useContext, useMemo } from "react";

export type TLinkRecommenderRecommendation = {
  id: string;
  material_log_title?: string | null;
  predicted_material_name?: string | null;
  activity_name?: string | null;
  activity_feature_instance_id: string;
  accepted?: boolean | null;
  activity_wbs_path?: string | null;
  job_id?: string | null;
  match_type?: string | null;
  match_confidence?: string | null;
  material_log_spec?: string | null;
  predicted_csi_spec?: string | null;
  reasoning?: string | null;
  phase?: string | null;
  location?: string | null;
  activity_type?: string | null;
  csi_div?: string | null;
};

export function useAISuggestedActivityIdsHook(props: {
  featureId: string | undefined;
  jobId: string | undefined;
  token: any;
  entiyType: EntityType;
  isEnabled: Boolean;
}) {
  const { featureId, jobId, entiyType, isEnabled } = props;
  const { gqlClientForProject } = useContext(ProjectContext);

  const shouldFetch = Boolean(
    featureId?.trim().length &&
    jobId?.trim().length &&
    isEnabled &&
    entiyType === EntityType.Material &&
    gqlClientForProject
  );

  const { data, loading, refetch } = useCIQQuery<{
    link_recommender_recommendation: TLinkRecommenderRecommendation[];
  }>(GET_LINK_RECOMMENDER_QUERY, {
    client: gqlClientForProject,
    variables: { feature_instance_id: featureId, job_id: jobId },
    skip: !shouldFetch
  });

  const suggestedIds = useMemo(() => {
    const recommendations = data?.link_recommender_recommendation;
    if (!recommendations) return undefined;
    return recommendations.map((item) => ({
      ...item,
      id: item.activity_feature_instance_id
    }));
  }, [data?.link_recommender_recommendation]);

  return { suggestedIds, loading, refetch };
}
